import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from "./utilites";
import ECommOrder from "./ecomm";

export default {
    applyOverrides: function () {
        //this is a custom checkout that just posts to the given payment provider and then updates the order to indicate all is good...
        ECommOrder.prototype.checkoutAsync =
            async function (opts = {}) {
                if (this.invalid) {
                    throw new Error("Order is Invalid");
                    return;
                }
                return new Promise(async (res, rej) => {

                    if (opts.address != null) await this.setAddressAsync(opts.address);
                    if (opts.billingAddress != null) await this.setBillingAddressAsync(opts.billingAddress);
                    if (opts.shippingAddress != null) await this.setShippingAddressAsync(opts.shippingAddress);

                    let orderinfo = await this.getInfoAsync();

                    const total = (await this.getCostsAsync()).Total;

                    //todo: update order additional json and notes to indicate payment was successful or not

                    const paymentOpts = Object.assign({ Amount }, opts.payment);
                    await paymentProvider.payAsync(paymentOpts);
                });
            }
    }
}



// WEBPACK FOOTER //
// ./Scripts/es6/ecommOverrides.js